module.exports = __webpack_public_path__ + "media/bootstrap-icons/check-all-803bdfea.svg";